export const LanguageManager = {
  getLanguage: () => {
    return localStorage.getItem("language");
  },
  setLanguage: (language: string) => {
    localStorage.setItem("language", language);
  }
};
